import { render, staticRenderFns } from "./ZavislostiPred.vue?vue&type=template&id=c5f4bb6c&"
import script from "./ZavislostiPred.vue?vue&type=script&lang=js&"
export * from "./ZavislostiPred.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports